module.exports = __webpack_public_path__ + "img/5dfc523.jpg";